import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Row, Col, Skeleton, Image } from 'antd'
import Link from 'next/link'

const Styled = styled.div`
 box-shadow: 0 8px 20px 5px rgba(0,0,0,0.1);
 min-width: 472px;
 min-height: 208px;
 display: flex;
 align-items: center;
 border-radius: 15px !important;
 
  .promo-title {
    margin-top: 10px;
  }
  .promo-box-loader {
    padding: 1px;
    border: 1px solid #f8f8ff;
    background: #ffffff;
    border-radius: 5px;
  }

  .promo-box {
    cursor: pointer;
    background: #ffffff;
    border-radius: 15px !important;

    .ant-image-img {
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
    }
  }

  .promo-description {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media only screen and (max-width: 768px) {
    min-width: 0 !important;
    width: 100% !important;
    padding: 12px 6px;

    .promo-title{
      margin: 0 !important;
    }
    .promo-title .ant-typography {
      font-size: 15px;
    }
    .promo-description .ant-typography {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 414px) {
    .promo-title .ant-typography {
      font-size: 16px;
    }
    .promo-description .ant-typography {
      font-size: 15px;
    }
  }

  @media only screen and (max-width: 411px) {  
    .ant-image-img {
      border-radius: 0 !important;
    }
    .promo-title .ant-typography {
      font-size: 15px;
    }
    .promo-description .ant-typography {
      font-size: 14px;

    }
  }

  @media only screen and (max-width: 375px) {
    .promo-title .ant-typography {
      font-size: 14px;
    }
    .promo-description .ant-typography {
      font-size: 13px;
    }
  }

  @media only screen and (max-width: 360px) {
    .promo-title .ant-typography {
      font-size: 13px;
    }
    .promo-description .ant-typography {
      font-size: 12px;
    }
  }

  @media only screen and (max-width: 320px) {
    .promo-title .ant-typography {
      font-size: 11px;
    }
    .promo-description .ant-typography {
      font-size: 10px;
    }
  }

  @media only screen and (max-width: 280px) {
    .promo-title .ant-typography {
      font-size: 10px;
    }
    .promo-description .ant-typography {
      font-size: 9px;
    }
  }
`

const SFNS = styled.div`
  @media only screen and (max-width: 768px) {
    font-size: 10px;
  }
`

const StyledTitle = styled.h3`
  color: var(--cognac);
  line-height: 30px;
`

export default function Index ({
  data
}) {
  return (
    <>
      <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
        <Styled>
          {!data &&
            <Row className='promo-box-loader my-2'>
              <Col span={8} className='center-vh'>
                <Image src={'/images/placeholder.png'} alt='' preview={false} />
              </Col>
              <Col span={14} offset={1}>
                <Row>
                  <Col span={24} className='promo-description'>
                    <Skeleton active />
                  </Col>
                </Row>
              </Col>
            </Row>}
          {data && <Link href={'/promos/' + (data.details[0].product_code)}>
            <Row className='promo-box my-2'>
              <Col span={8} className='center-vh'>
                <Image src={data.details[0].thumbnail || '/images/placeholder.png'} alt='' preview={false} />
              </Col>
              <Col span={15} offset={1}>
                <Row>
                  <Col
                    className='promo-title'
                    span={24}
                  >
                    {!data.details.supercardExclusive && <>
                      <div className='mt-3' />
                      <StyledTitle>{data.title}</StyledTitle>
                      <div className='my-3' />
                    </>}
                    {data.details.supercardExclusive && <SFNS size='18'>{data.title} <img src='/images/supercard-icon.png' alt='' /></SFNS>}
                  </Col>
                  <Col span={23} className='promo-description'>
                    <SFNS size='14' color='dusty-grey' fWeight='normal'>
                      <div dangerouslySetInnerHTML={{ __html: data.details[0].description }} />
                    </SFNS>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Link>}
        </Styled>
      </Col>
    </>
  )
}

Index.propTypes = {
  data: PropTypes.object
}
